import { ErrorHandler, inject, Injectable } from '@angular/core';

import { SentryService } from '@services/sentry.service';

function isErrorOrErrorEvent(error: any): boolean {
  return (
    Object.prototype.toString.call(error) === '[object Error]' ||
    Object.prototype.toString.call(error) === '[object ErrorEvent]'
  );
}

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private readonly sentryService = inject(SentryService);

  handleError(error: Error & { originalError?: Error }): void {
    error = error.originalError || error;
    if (isErrorOrErrorEvent(error)) {
      this.sentryService.captureException(error);
    } else {
      console.error(error);
    }
  }
}
